import React from "react";

import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "~/lib/prose/nodes/keyResult/keyResult.module.css";

type NoAccessEmbeddedKeyResultProps = React.PropsWithChildren<{
	title: string;
	icon: IconDefinition;
}>;

export default function NoAccessEmbeddedKeyResult({ title, icon, children }: NoAccessEmbeddedKeyResultProps) {
	return (
		<article className={styles.noAccess}>
			<h1>
				<FontAwesomeIcon icon={icon} fixedWidth /> {title}
			</h1>
			{children}
		</article>
	);
}
